import axesPostRenderYAxis from './axes-postrender-y-axis';
import axesPostRenderXAxis from './axes-postrender-x-axis';

export default function axesPostRender(highchart, options, styles) {
  makeLinesCrisp(highchart, options);
  if (options.type !== 'pie') {
    axesPostRenderYAxis(highchart, options, styles);
    axesPostRenderXAxis(highchart, options, styles);
  }

  if (__WSJ__) {
    if (options.product === 'wsj' && options.print && (options.type !== 'bar' && options.type !== 'pie') ) {
      const suffix = highchart.container.getElementsByClassName('units y-axis-suffix')[0];
      suffix.style.fill = 'rgb(0, 0, 0)';
    } 
  }


  if (options.print && options.type === 'bar') {
    const barCont = highchart.container.getElementsByClassName('highcharts-bar-series');
    for (let i = 0; i < barCont.length; i++ ) {
      const highchartBarG = barCont[i];
      const highchartBarGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartBarG.getAttribute('transform'));
      const xValTranslate = parseInt(highchartBarGTransformVal[1]) - 1.5;
      highchartBarG.transform.baseVal.getItem(0).setTranslate(xValTranslate, parseInt(highchartBarGTransformVal[2]));
    }
  }
  if (options.print && options.type === 'column') {
    if (options.product === 'wsj') {
      const seriesGroup = highchart.container.getElementsByClassName('highcharts-series-group')[0];
      const seriesGroupTransformVal = seriesGroup.transform.baseVal.getItem(0).matrix.f;
      const seriesGroupYVal = seriesGroupTransformVal - 1;
      seriesGroup.transform.baseVal.getItem(0).setTranslate(0, seriesGroupYVal);
    }
    const colCont = highchart.container.getElementsByClassName('highcharts-column-series');
    for (let i = 0; i < colCont.length; i++) {
      const highchartColumnG = colCont[i];
      const highchartColumnGTransformVal = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(highchartColumnG.getAttribute('transform'));
      const yValTranslate = parseInt(highchartColumnGTransformVal[2]) + 1;
      highchartColumnG.transform.baseVal.getItem(0).setTranslate(parseInt(highchartColumnGTransformVal[1]), yValTranslate);
    }
    if (options.product === 'wsj') {
      const rectGroup = highchart.container.getElementsByClassName('highcharts-point');
      for (let h = 0; h < rectGroup.length; h++) {
        const rect = rectGroup[h];
        const rectHeight = parseInt(rect.getAttribute('height'));
        const rectY = parseInt(rect.getAttribute('y'));
        rect.setAttribute('height', rectHeight + 1);
        rect.setAttribute('y', rectY - 2);
      }
    }
  }

  if (__WSJ__) {
    if (options.product === 'wsj' && options.type === 'bar') {
      const yAxis = highchart.container.getElementsByClassName('highcharts-yaxis-labels');
      yAxis[0].setAttribute('transform', 'translate(0, 2)');

      // align h-bar xAxis labels to the left
      const xAxis = highchart.container.getElementsByClassName('highcharts-xaxis-labels');
      const xLabels = xAxis[0].childNodes;

      xLabels.forEach(label => {
        label.setAttribute('x', '0');
        label.setAttribute('text-anchor', 'start');

        const tspans = label.childNodes;

        tspans.forEach(tspan => {
          tspan.setAttribute('x', '0');
        });
      });
    }
  }
}

// Ensures lines are offset by 0.5 to ensure crispness.
// TODO: If ever combining inner and outer charts, revisit this function!
function makeLinesCrisp(highchart, options) {
  const g = highchart.container.querySelectorAll('svg > g');

  for (let i = 0; i < g.length; i++) {
    const list = g[i].classList;

    if (!list.contains('highcharts-legend')) {
      g[i].setAttribute('transform', 'translate(0, 0.5)');
    }

    if (__WSJ__) {
      if (options.product === 'wsj') {
        if(list.contains('highcharts-xaxis')){
          g[i].setAttribute('transform', `translate(0, ${options.styles.tick.yOffset})`);
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/chart/inner/axes-postrender.js